import script from "./WorkHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkHistory.vue?vue&type=script&setup=true&lang=ts"

import "./WorkHistory.vue?vue&type=style&index=0&id=4132186a&lang=less&scoped=true"

import exportComponent from "/home/runner/work/Portfolio/Portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4132186a"]])

export default __exports__